import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { IAPIArrayData } from '@shared/interfaces/api.interface';
import { ICandidate } from '@shared/interfaces/candidate.interface';
import { IDocument } from '@shared/interfaces/document.interface';
import { CandidatesDocumentsService } from '@shared/services/candidates/candidates.documents.service';
import { ImpersonationService } from '@shared/services/impersonation.service';
import { LoggerService } from '@shared/services/logger.service';

@Component({
    selector: 'app-sidebar-candidate-documents',
    templateUrl: './sidebar.candidate.documents.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SidebarCandidateDocumentsComponent implements OnInit {
  @Input() public candidate: ICandidate;

  public isLoading = Boolean(true);
  public documents: IDocument[] = [];

  // True while a Vitay support engineer is acting as this recruiter. The API
  // refuses document downloads for those sessions, so the UI hides the control
  // and says why rather than letting the click fail.
  public get isSupportMode(): boolean {
    return this._impersonation.isImpersonating;
  }

  private readonly constructorName: string = String(this.constructor.name);

  constructor(
    private readonly _candidateDocuments: CandidatesDocumentsService,
    private readonly _logger: LoggerService,
    private readonly _impersonation: ImpersonationService
  ) {}

  ngOnInit(): void {
    const url = `GET /candidates/${this.candidate.id}/documents`;
    this._candidateDocuments
      .getPage(
        1,
        (data: IAPIArrayData) => this._logger.info(this.constructorName, url, data),
        { key: 'id', value: String(this.candidate.id) }
      )
      .subscribe(
        (res: IDocument[]) => {
          this.documents = res;
          this.isLoading = false;
        },
        (err: any) => {
          this._logger.error(this.constructorName, url, err);

          this.isLoading = false;
        }
      );
  }

  // The API mints a short-lived URL per download and records it in the
  // candidate's activity feed, so documents are never opened from a stored link.
  public download(doc: IDocument): void {
    if (doc.quarantined || this.isSupportMode) {
      return;
    }

    const url = `GET /candidates/${this.candidate.id}/documents/${doc.id}/download`;

    doc.isDownloading = true;

    this._candidateDocuments.openDocument(this.candidate.id, doc.id).subscribe({
      next: () => (doc.isDownloading = false),
      error: (err: any) => {
        this._logger.error(this.constructorName, url, err);

        doc.isDownloading = false;
      }
    });
  }
}
